<template>
  <div class="five-star-cms" v-if="!mobiTablet">
    <!-- <loading-page :isLoading="loading"></loading-page> -->
    <page-header @changeDrawerAplication="drawerApplication = !drawerApplication"/>
    <left-menu v-if="!loading" />
    <div id="main-wrapper" :class="(hideSidebar) ? 'hide-sidebar' : ''">
      <v-alert
        
        prominent
        text
        dense
        type="error"
        icon="mdi-cloud-alert"
        v-if="isExpired && isOpen == true"
      >
      <v-row align="center">
          <v-col class="grow">
            <span class="fs-14">
              {{  oaGroup.filter(e => e.date <= 15).map(g => $t(  g.date <= 15 && g.date > 0 ? "TEXT_NOTIFY_WILL_EXPIRE_GROUP_OTA" : "TEXT_NOTIFY_EXPIRED_GROUP_OTA", {
                  channel: g.name,
                  date: utcConvertToLocalTimeZoneAndFomat(g.endDate)
                })).join(". ") 
                
              }}
            </span>
            <span class="fs-14" v-html="$t('PLEASE_RENEW')"></span>
          </v-col>
          <v-col class="shrink">
            <v-btn color="error" @click="closeNoti" fab dark x-small>
              <i class="icon-close fs-16 font-weight-bold"></i>
            </v-btn>
          </v-col>
        </v-row>
        
      </v-alert>
    <v-slide-x-transition :hide-on-leave="true">
        <router-view />
      </v-slide-x-transition>
    </div>
    <!-- <ex-alert /> -->
    <v-navigation-drawer
      v-model="drawerApplication"
      absolute
      temporary
      right
      class="d-application"
    >
      <div class="d-app">
        <div class="d-app-header">
          <div class="d-flex">
            <div class="d-infomation">
              <v-list-item two-line>
                <v-list-item-avatar>
                  <img v-if="!user.user.avatar" src="@/assets/svg/account-circle.svg"/>
                  <img v-else :src="user.user.avatar">
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title><strong>{{user.user.fullName}}</strong> - <span class="fs-10">{{user.user.group}}</span></v-list-item-title>
                  <v-list-item-subtitle>
                    <v-btn color="warning" text x-small class="btn-subtitle" @click="goToPersonalSetting">{{ $t("PERSONAL_ACCOUNT_SETTING") }}</v-btn> . 
                    <v-btn color="warning" text x-small class="btn-subtitle" @click="logout">{{ $t("LOG_OUT") }}</v-btn>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </div>
        <div class="d-app-content" v-if="domain.includes('ezcrs') || domain.includes('ezcms') || domain == 'localhost'">
          <div class="d-search-application">
            <v-text-field class="w-100" v-model="keySearchApp" solo dense :label="$t('ENTER_THE_NAME_OF_THE_APP_WANT_TO_SEARCH_FOR')" prepend-inner-icon="search"></v-text-field>
          </div>
          <v-expansion-panels accordion multiple v-model="panel">
            <v-expansion-panel
              v-for="(item,i) in arrAppView"
              :key="i"
            >
              <v-expansion-panel-header>{{$i18n.locale === 'en' ? item.nameEn : item.name}}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <b-row>
                  <b-col md="3" v-for="(app, index) in item.appLinks" class="text-center d-app-item py-0" @click="openApp(app)">
                    <div class="d-img-app">
                      <img :src="app.icon">
                    </div>
                    <div class="fs-12">
                      {{app.name}}
                      <p class="fs-10 text-secondary">{{$i18n.locale === 'en' ? app.descriptionEn : app.description}}</p>
                    </div>
                  </b-col>
                </b-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div class="h-100 d-flex align-items-center justify-content-center" v-if="arrAppView.length === 0">
            {{$t('REQUEST_EMPTY')}}
          </div>
        </div>
        <div class="d-app-footer">
          <div class="d-flex">
            <div class="mr-auto align-self-center">
              <div @click="changeDevice('MOBILE')" v-if="isMobiTablet && !mobiTablet" class="pl-3">
                <v-icon class="icon mr-3 text-primary">desktop_access_disabled</v-icon>
                <span>{{ $t("VIEW_MOBILE_VERSION") }}</span>
              </div>
            </div>
            <div class="text-center">
              <div>
                <strong class="fs-18">{{time.hour}} : {{time.minute}}</strong> <strong class="fs-10"> : {{time.second}}</strong>
              </div>
              <div class="fs-10">
                {{time.day}} {{time.local}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
  <div class="five-star-cms" v-else>
    <page-header />
    <div id="main-wrapper-mobi" :class="(hideSidebar) ? 'hide-sidebar' : ''">
      <v-slide-x-transition :hide-on-leave="true">
        <router-view />
      </v-slide-x-transition>
    </div>
    <v-bottom-navigation v-model="valuePage" color="primary">
        <v-btn @click="changePage('listBooking')" :value="1">
          <span class="fs-8">{{$t("BOOKING")}}</span>
          <v-icon>event_note</v-icon>
        </v-btn>

        <v-btn @click="changePage('inventory')" :value="2">
          <span class="fs-8">{{$t("ROOM_AVAIL")}}</span>
          <v-icon>inventory</v-icon>
        </v-btn>

        <v-btn @click="changePage('mRate')" :value="3">
          <span class="fs-8">{{$t("RATE")}}</span>
          <v-icon>star_border</v-icon>
        </v-btn>

        <!-- <v-btn @click="changePage('app')" :value="5">
          <span class="fs-8">{{$t("APP")}}</span>
          <v-icon>apps</v-icon>
        </v-btn> -->

        <v-btn :value="4" @click.stop="drawer = !drawer">
          <span class="fs-8">Menu</span>
          <v-icon>menu</v-icon>
        </v-btn>
    </v-bottom-navigation>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      right
    >
      <v-list-item>
        <v-list-item-avatar class="mr-2">
          <v-img  v-if="!user.user.avatar" src="@/assets/svg/account-circle.svg"></v-img>
          <v-img v-else :src="user.user.avatar" alt></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            <p class="mb-0 font-weight-bold">{{ user.user.fullName }}</p>
            <p class="mb-0 fs-10">{{ user.user.group }}</p>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="mt-0 mb-0"></v-divider>

      <v-list>
        <v-list-item @click="changePage('chain-list')">
          <v-list-item-icon>
            <v-icon>desktop_windows</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="fs-10">{{$t("HOTEL_CHAIN")}}</v-list-item-title>
        </v-list-item>

        <v-list-group
          :value="true"
          prepend-icon="language"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="fs-10">{{$t('HOTEL_LOG_lang')}}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item @click="changeLanguage('vi')">
            <v-list-item-content>
              <v-list-item-title class="fs-10 list-child-title">{{$t('VIETNAMESE')}} <v-icon class="fs-10 text-success i-dot-active" v-if="$i18n.locale === 'vi'">fiber_manual_record</v-icon></v-list-item-title>
            </v-list-item-content>
            <v-list-item-avata size="25">
              <img src="@/assets/svg/1-i-icon-language-vi.svg"/>
            </v-list-item-avata>
          </v-list-item>
          <v-list-item @click="changeLanguage('en')">
            <v-list-item-content>
              <v-list-item-title class="fs-10 list-child-title">{{$t('ENGLISH')}} <v-icon class="fs-10 text-success i-dot-active" v-if="$i18n.locale === 'en'">fiber_manual_record</v-icon></v-list-item-title>
            </v-list-item-content>
            <v-list-item-avata size="25">
              <img src="@/assets/svg/1-i-icon-language-eng.svg"/>
            </v-list-item-avata>
          </v-list-item>
        </v-list-group>

        <v-list-group v-if="checkRoleFunc('STOP_SELL_LIMIT')"
          :value="false"
          prepend-icon="settings"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="fs-10">{{$t('OTHER_FUNCTION')}}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item @click="changePage('stopSell')" >
            <v-list-item-content>
              <v-list-item-title class="fs-10 list-child-title">{{$t('STOP_SELL')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item @click="changePage('app')" v-if="domain.includes('ezcrs') || domain.includes('ezcms') || domain == 'localhost'">
          <v-list-item-icon>
            <v-icon>apps</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="fs-10">{{$t("APP")}}</v-list-item-title>
        </v-list-item>

        <v-list-item @click="changeDevice('DESKTOP')">
          <v-list-item-icon>
            <v-icon>important_devices</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="fs-10">{{$t("VIEW_DESKTOP_VERSION")}}</v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-icon>
            <v-icon>perm_phone_msg</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="fs-10">{{$t("CONTACT_US")}}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout()">
          <v-list-item-icon>
            <v-icon>logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="fs-10">{{$t("LOG_OUT")}}</v-list-item-title>
        </v-list-item>
        <v-list-item style="position: absolute; bottom: 0; right: 0">ezCrs {{ version }}</v-list-item>
      </v-list>
      <v-list>
        
      </v-list>
    </v-navigation-drawer>
    <!-- <ex-alert /> -->
  </div>
</template>

<script>
import { authenticationService } from "@/_services";
import moment from "moment";
// import LoadingPage from "@/components/Utils/LoadingPage.vue";
import { systemService } from "@/_services/system-data.service.js";
import {
  _storedUserInfo
} from "@/_helpers/function.js";

export default {
  components: {
    // "ex-alert": () => import('@/components/Utils/Alert.vue'),
    "page-header": () => import('@/components/Utils/Header.vue'),
    "left-menu": () => import('@/components/Utils/LeftMenu.vue'),
    // "loading-page": LoadingPage
  },
  data() {
    return {
      env: process.env,
      hideSidebar: JSON.parse(localStorage.getItem("hideSidebar")),
      drawer: false,
      user: null,
      time: {
        day: '',
        hour: '',
        minute: '',
        second: '',
        local: ''
      },
      drawerApplication: false,
      apps: [],
      panel: [0, 1],
      arrAppView: [],
      keySearchApp: null,
      timeZoneStr: localStorage.getItem("timeZoneStr"),
      GMT: localStorage.getItem("GMT"),
      lang: this.$i18n.locale,
      actionloading: true,
      oaGroup: [],
      isExpired: false,
      isOpen: true,
      modules: null
    };
  },
  created() {
    this.user =  JSON.parse(localStorage.getItem("currentUser"));
    this.getApplication();
    this.$eventHub.$on('eventLoading', e => {
      this.actionloading = e;
    });
    this.isOpen = this.$session.exists() && this.$session.getAll().notify_expired ? true : false
  },
  computed: {
    loading() {
      return this.actionloading;
    },
    valuePage() {
      let val = 4;
        switch (this.$route.name) {
        case 'listBooking':
          val = 1;
          break;
        case 'inventory':
          val = 2;
          break;
      
        case 'rate':
          val = 3;
          break;

        case 'app':
          val = 5;
          break;

        default:
          val = 4;
          break;
      }
      return val
    }
  },
  watch: {
    keySearchApp(val) {
      this.arrAppView = this.filterData(this.apps, val);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.clock();
      
    })
  },
  methods: {
    closeNoti(){
      this.isOpen = false;
      // setTimeout(this.openNotification, 15*60*1000);
      this.$session.set('notify_expired', false); 
      this.$forceUpdate()
    },
    openNotification() {
      this.isOpen = true;
    },
    inDays(d1, d2) {
      var t2 = d2.getTime();
      var t1 = d1.getTime();

      return parseFloat((t2 - t1) / (24 * 3600 * 1000));
    },
   async getModuleAccess() {
      this.actionloading = true;
    await  systemService
        .getModuleAccess()
        .then(res => {
          let modules = res.data.filter(m => m.active == 1).map(e => Object.assign({}, {
            fnCode: e.code,
            fnName: e.name,
            id:  e.id,
            parentId: "ota"
          }));
          this.oaGroup = res.data.filter(m => m.active == 1).map(e => Object.assign(e, {date: this.inDays(new Date(), new Date(e.endDate))}));
          this.isExpired  = this.oaGroup.filter(e => e.date <= 15).length > 0;
          let currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
          let fn = currentUser.user.roles.filter(e => e.parentId != 'ota').concat(modules)
          _storedUserInfo("user/roles", fn);
          this.actionloading = false;
        })
    },
    getOtaGroup() {
      systemService
        .getOtaGroup()
        .then(res => {
          // this.oaGroup = res.data.map(e => Object.assign(e, {date: this.inDays(new Date(), new Date(e.endDate))}));
          // this.isExpired  = this.oaGroup.filter(e => e.date <= 15).length > 0;
          this.getModuleAccess()
        })
    },
    openApp(app) {
      if (app.url) {
        window.open(app.url ? app.url : '#');
      }
    },
    filterData(arr, key) {
      const array = JSON.parse(JSON.stringify(arr));
      if (key) {
        for (let index = 0; index < array.length; index++) {
          array[index].appLinks = array[index].appLinks.filter(app => app.name.toLowerCase().includes(key.toLowerCase()))
        }
        return array.filter(e => e.appLinks.length > 0);
      }
      return arr
    },
    getApplication() {
       authenticationService
        .getApp()
        .then(res => {
          this.apps = res.data;
          this.arrAppView = res.data;
          // this.filterData(this.apps, 'Cms')
          this.getOtaGroup()
        })
    },
    goToPersonalSetting() {
      this.$router.push({ name: "accountSetting" });
    },
    clock(){
      var day = null;
      var t  = null;
      var timer = null;
      var hour= null;
      var minute  = null;
      var second = null;
      setInterval(() => {
         day = new Date();
         t = day.toLocaleString(
            'en-US', 
            { timeZone: this.timeZoneStr }
        );
         timer = new Date(t);
         hour = timer.getHours();
         minute = timer.getMinutes();
         second = timer.getSeconds();
        if(hour < 10) {
            hour = "0" + hour;
        }
        if(minute < 10) {
            minute = "0" + minute;
        }
        if(second < 10) {
            second = "0" + second;
        }
        this.time = {
          day: moment(t).format( this.lang === 'en' ? "YYYY/MM/DD" : "DD/MM/YYYY"),
          hour: hour,
          minute: minute,
          second: second,
          local: this.GMT
        }
        // this.time = moment(t).format(outputFormat) + " " + hour + ":" + minute + ":" + second  + ' ' + localStorage.getItem("GMT");
        // this.isOpen = this.$session.get("notify_expired") == false ? false : true
      }, 1000);
    },
    changeDevice(val) {
      localStorage.setItem("device", val);
      this.$router.push({ name: "chain-dashboard" });
      setTimeout(() => {
        location.reload();
      }, 200);
    },
    changeLanguage(lang) {
      localStorage.setItem("systemLanguage", lang);
      location.reload();
    },
    changePage(val) {
      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
      this.$router.push({
        name: val,
        params: { hotelIdParam: currentUser.hotel.id }
      });
    },
    logout() {
      if (this.domain.includes('ezcrs') || this.domain.includes('ezcms') || (this.dataMain && this.dataMain.isLoginAdmin === false)) {
      authenticationService.logout();
      this.$oidc.signoutRedirect();
      } else {
        localStorage.removeItem("arrToken");
        localStorage.removeItem("currentUser");
        this.$router.push({ name: "login-admin" });
      }
      // authenticationService.logout();
      // this.$oidc.signoutRedirect();
      // this.$router.push({ name: "login" });
      // // }
      // location.reload();
    },
    _moment: moment
  }
};
</script>